import ProductService from '_services/rest/modules/product';

export default {
  state: {
    service: null,
    equipments: null,
    serviceList: null,
  },
  mutations: {
    setService(state, response) {
      state.service = response;
    },
    setEquipments(state, response) {
      state.equipments = response;
    },
    setServiceList(state, response) {
      state.serviceList = response;
    },
  },
  actions: {
    getServiceList({ commit }, params) {
      return ProductService.getList(params).then(response => {
        commit('setServiceList', response);
      });
    },
    getService({ commit }, params) {
      return ProductService.getProductById(params)
        .then(response => {
          commit('setService', response);
        });
    },
    getEquipments({ commit }, params) {
      return ProductService.getEquipments(params)
        .then(response => {
          commit('setEquipments', response);
        });
    },
    setService({ commit }, params) {
      commit('setService', params);
    },
  },
};
